import React from 'react';

import _ from 'lodash';
import { makeStyles } from 'tss-react/mui';
import { Box, Typography } from '@mui/material';
import { Icon, Popup } from 'semantic-ui-react';
import DOMPurify from 'dompurify';

import OhsLoginFooter from 'login/OhsLoginFooter';
import { useQuery } from 'global-components/tab/OhsTab';
import { eventSuccesfulMessageMap } from 'qr-code/models/OhsQrCodeModels';
import { getLocalOhsGuestQrCodeData } from 'qr-code/utils/OhsQrCodeUtils';

import scLogo from '../../../angular-modules/build/img/sc-logo.png';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  logo: {
    width: '50%',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '100vh',
  },
  footer: {
    marginBottom: theme.spacing(2),
  },
  greenText: {
    color: theme.palette.success.main,
    textAlign: 'center',
    margin: '10px 15px 25px 15px',
    fontSize: '1.8rem',
    fontWeight: '510',
  },
  qrCodeDisplayMessage: {
    width: '90%',
    maxWidth: '500px',
    margin: '0px',
  },
  referenceContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '15px 25px 20px 25px',
    textAlign: 'center',
    gap: '5px',
    fontSize: '1.5rem',
    fontWeight: '500',
    color: '#302648',
  },
  referenceIDBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderRadius: '8px',
    padding: '8px 3px 8px 12px',
    minWidth: '155px',
    fontWeight: 'bold',
    border: '1px solid #8E8A9B',
    backgroundColor: '#f9f9f9',
  },
  copyIcon: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
  staticTextOne: {
    color: '#302648',
    fontWeight: '510',
    width: '65%',
    margin: '20px 10px 0px 10px',
    textAlign: 'center',
    fontSize: '1.4rem',
  },
  staticTextTwo: {
    color: '#605973',
    width: '60%',
    margin: '20px 10px 10px 10px',
    textAlign: 'center',
    fontSize: '1.14rem',
  },
}));

export default function OhsQrCodeSuccessOperationHome() {
  const { classes } = useStyles();
  const query = useQuery();
  const [copied, setCopied] = React.useState(false);

  const moduleType = query.get('mt') || '';
  const eventType = query.get('et') || '';
  const referenceId = query.get('ref');
  const guestQrCodeData = getLocalOhsGuestQrCodeData();

  const formattedEventType = eventSuccesfulMessageMap[eventType] || _.capitalize(eventType);

  const handleCopy = () => {
    if (!referenceId) return;
    navigator.clipboard.writeText(referenceId);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.root}>
        <Box maxWidth="xs" display="flex" justifyContent="center" marginBottom="15px">
          <img className={classes.logo} src={scLogo} alt="Safety Champion" />
        </Box>
        <Icon name="check" color="green" size="massive" />
        <Typography component="div" className={classes.greenText}>
          {moduleType} {formattedEventType || 'Submitted'} Successfully
        </Typography>

        {referenceId && (
          <Box className={classes.referenceContainer}>
            <Typography variant="inherit" component="div">
              {moduleType} ID
            </Typography>
            <Typography variant="inherit" component="div">
              :
            </Typography>
            <Box className={classes.referenceIDBox}>
              {referenceId}
              <Popup
                content={copied ? 'Copied' : 'Click to copy reference ID'}
                trigger={
                  <Icon
                    name={copied ? 'check' : 'copy outline'}
                    className={classes.copyIcon}
                    onClick={handleCopy}
                  />
                }
              />
            </Box>
          </Box>
        )}

        {guestQrCodeData && guestQrCodeData?._id && guestQrCodeData?.displayMessage && (
          <Box
            className={`${classes.qrCodeDisplayMessage} ql-editor`}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(guestQrCodeData?.displayMessage),
            }}
          />
        )}
        <Typography component="div" className={classes.staticTextTwo}>
          We appreciate you keeping an eye out for others.
        </Typography>
      </Box>
      <Box className={classes.footer}>
        <OhsLoginFooter />
      </Box>
    </Box>
  );
}
